module.exports = __webpack_public_path__ + "static/img/fish16.0d3e726.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish16.png
// module id = SH/9
// module chunks = 0